module.exports = __webpack_public_path__ + "static/contact_bg-49b377847ecbc69b7dce9c800daf2ae2.png";